import { createUseRecipeHook } from '@/style/utils/createUseRecipeHook';
import { RecipeVariants } from '@/style/utils/createRecipeObj';
import * as style from './CardGrid.css';

export const useCardGridStyle = createUseRecipeHook(style.root);

export type CardGridStyleProps = RecipeVariants<typeof style.root>;
